import { render, staticRenderFns } from "./AdminBaseZones.vue?vue&type=template&id=95090af8"
import script from "./AdminBaseZones.vue?vue&type=script&lang=js"
export * from "./AdminBaseZones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports